'use client';

import React from 'react';
import { cn } from '@/lib/utils';

type LogoProps = {
  /** Show text alongside the logo */
  showText?: boolean;
  /** Logo size variant */
  size?: 'sm' | 'md' | 'lg';
  /** Additional class names */
  className?: string;
};

export function Logo({ showText = true, size = 'md', className }: LogoProps) {
  // Size mappings for the circle icon
  const sizeMap = {
    sm: 'w-5 h-5',
    md: 'w-7 h-7',
    lg: 'w-9 h-9',
  };

  // Size mappings for the text
  const textSizeMap = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-xl',
  };

  // Spacing between icon and text
  const spacingMap = {
    sm: 'gap-1',
    md: 'gap-2',
    lg: 'gap-3',
  };

  return (
    <div className={cn('flex items-center', spacingMap[size], className)}>
      {/* Logo icon */}
      <div className={cn(sizeMap[size], 'relative')}>
        <img
          src="/logo.svg"
          alt="Bleep Logo"
          className="h-full w-full dark:invert"
        />
      </div>

      {/* Logo text */}
      {showText && (
        <span className={cn('font-semibold', textSizeMap[size])}>Bleep</span>
      )}
    </div>
  );
}
